import { c as _c } from "react/compiler-runtime";
import { LayoutContainer, SkeletonBar } from '@petsmart-ui/sparky';
import './FeedbackSkeleton.scss';
export function FeedbackSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LayoutContainer className="feedback-skeleton"><SkeletonBar aria-hidden="true" className="feedback-skeleton__text" /><SkeletonBar aria-hidden="true" className="feedback-skeleton__button" /></LayoutContainer>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}